export const OAUTH_PROVIDER = [
  "Amazon",
  "AOL",
  "Autodesk",
  "Apple",
  "Basecamp",
  "Battle.net",
  "Bitbucket",
  "bitly",
  "Box",
  "ClearScore",
  "Cloud Foundry",
  "Dailymotion",
  "Deutsche Telekom",
  "deviantART",
  "Discogs",
  "Discord",
  "Dropbox",
  "Etsy",
  "Evernote",
  "Facebook",
  "FatSecret",
  "Fitbit",
  "Flickr",
  "Formstack",
  "Foursquare",
  "GitHub",
  "GitLab",
  "Goodreads",
  "Google",
  "Google App Engine",
  "Groundspeak",
  "Huddle",
  "Imgur",
  "Instagram",
  "IntelCloud Services",
  "Jive Software",
  "Keycloak",
  "LinkedIn",
  "LoginRadius",
  "Microsoft services",
  "Mixi",
  "MySpace",
  "MoreTeam",
  "Netflix",
  "NetIQ",
  "Okta",
  "OpenAM",
  "OpenStreetMap",
  "OpenTable",
  "ORCID",
  "PayPal",
  "Ping Identity",
  "Pixiv",
  "Plurk",
  "Reddit",
  "Salesforce.com",
  "Sina Weibo",
  "Spotify",
  "Stack Exchange",
  "StatusNet",
  "Strava",
  "Stripe",
  "Trello",
  "Tumblr",
  "Twitch",
  "Twitter",
  "Ubuntu One",
  "Viadeo",
  "Vimeo",
  "VK",
  "WeChat",
  "Withings",
  "WooCommerce",
  "WordPress.com",
  "WSO2 Identity Server",
  "Xero",
  "XING",
  "Yahoo!",
  "Yammer",
  "Yandex",
  "Yelp",
  "Zendesk",
];
